import Text13 from './Text13'
export default Text13
